import { abortIfNotPermitted } from '../../utils';
import Auth from '@js/plugins/auth';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "distributor" */ '@js/franchise_component/franchise-inventory/distributor/distributor-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_distributor',
                next,
            );
        },
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "distributor" */ '@js/franchise_component/franchise-inventory/distributor/distributor-create.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_inventory_distributor',
                () => {
                    if (
                        !Auth.hasPermissionTo(
                            'franchise_manage_inventory_distributor',
                        )
                    ) {
                        abortIfNotPermitted(
                            'franchise_create_inventory_distributor',
                            next,
                        );
                    } else {
                        next();
                    }
                },
            );
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "distributor" */ '@js/franchise_component/franchise-inventory/distributor/distributor-edit.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_distributor',
                next,
            );
        },
    },
];
